import { useState } from "react"

import { Stack, Badge, Box, SvgIcon, Typography, Button, Menu, MenuItem } from "@mui/material"
import {
	PriceTag3LineIcon,
	FolderDownloadLineIcon,
	DownloadLineIcon,
	FileExcelLineIcon,
} from "@equipmentshare/ds2-icons"

import type { BulkLabel } from "@app/services/types"
import type { ExportType } from "./LabelDataGrid"

type LabelViewHeaderProps = {
	bulkLabels: BulkLabel[]
	onExportFile?: (fileType: ExportType) => void
}

export const LabelViewHeader: React.FC<LabelViewHeaderProps> = ({ bulkLabels, onExportFile }) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
	const open = Boolean(anchorEl)

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget)
	}
	const handleClose = () => {
		setAnchorEl(null)
	}

	const exportMenu = (
		<Menu id="export-menu" anchorEl={anchorEl} open={open} onClose={handleClose}>
			<MenuItem
				onClick={() => {
					onExportFile?.("excel")
					handleClose()
				}}
			>
				<Stack direction="row" alignItems="center" gap={1}>
					<SvgIcon component={FileExcelLineIcon} /> Excel
				</Stack>
			</MenuItem>
			<MenuItem
				onClick={() => {
					onExportFile?.("csv")
					handleClose()
				}}
			>
				<Stack direction="row" alignItems="center" gap={1}>
					<SvgIcon component={FolderDownloadLineIcon} /> CSV
				</Stack>
			</MenuItem>
		</Menu>
	)

	return (
		<Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" sx={{ p: "12px" }}>
			<Badge
				color="primary"
				badgeContent={bulkLabels.length}
				sx={{
					"& .MuiBadge-badge": {
						right: -20,
						top: 15,
					},
				}}
			>
				<Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
					<SvgIcon component={PriceTag3LineIcon} />
					<Typography variant="h6" fontWeight="bold">
						IDs
					</Typography>
				</Box>
			</Badge>
			<Button
				aria-controls={open ? "export-menu" : undefined}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				disabled={!bulkLabels.length}
				onClick={handleClick}
				variant="outlined"
				startIcon={<SvgIcon component={DownloadLineIcon} />}
			>
				Download File
			</Button>
			{exportMenu}
		</Stack>
	)
}
export default LabelViewHeader
